import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { TransformObject } from 'src/utils/serialization';
import { _Data_To_Obj } from 'src/utils/staticData';
import { DictionaryActionTypes } from './type';

function* fetch_dictionary_list() {
  while (true) {
    const action = yield take(DictionaryActionTypes.FETCH_DICTIONARY_LIST);
    try {
      const { resourcesEnumsList } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/resource/list', type: 'POST', data: resourcesEnumsList, needLogin: false,
      });
      if (res && res.code === '0') {
        const { result = {} } = res;
        const data = resourcesEnumsList.reduce((prev: object, key: string) => {
          prev[`${key}_OBJ`] = TransformObject(result[key], 'resCode', 'resName');
          return prev;
        }, result);
        yield put({ type: DictionaryActionTypes.FETCH_DICTIONARY_LIST_SUCCESS, data });
      }
    } catch (error) {
      StaticToast.error('获取枚举信息失败，请稍后重试');
      // StaticToast.error(`fetch_resource--------${JSON.stringify(error)}`);
    }
  }
}


export default function* root() {
  yield all([
    fork(fetch_dictionary_list),
  ]);
}
